import configurations from '@Apis/configurations.api';
import {
	ConfigurationParams,
	CreateConfigurationParams,
	DeleteConfigurationParams,
	MultipleDeleteParams,
} from './../types/configurations.types';
import { ALLOWED_BULK_DELETE_DATA_SOURCE_TYPES } from '@Utils/constants';

export const getConfigurationById = (
	sensorId: string,
	params: ConfigurationParams,
) => {
	const uriEncodedSensorId = encodeURIComponent(sensorId);
	return configurations.get(`/configurations/${uriEncodedSensorId}`, {
		params,
	});
};

export const getConfigurations = (params: ConfigurationParams) =>
	configurations.get('/configurations', {
		params,
	});

export const getConfigurationsRfi = (params: ConfigurationParams) =>
	configurations.get('/configurations', {
		headers: { accept: 'text/csv' },
		params: {
			limit: 1000, // ? page size (default value)
			offset: 1, // ? page (default value)
			...params,
			configType: 'sensor',
		},
	});

export const getSensorsReadingsCount = () =>
	configurations.get('/sensors/aggregates/readingcount', {
		headers: { accept: 'text/csv' },
	});

export const createConfigurations = (params: CreateConfigurationParams) =>
	configurations.post('/configurations', params);

export const updateConfigurationById = (
	sensorId: string,
	params: CreateConfigurationParams,
) => {
	const uriEncodedSensorId = encodeURIComponent(sensorId);
	return configurations.patch(
		`/configurations/${uriEncodedSensorId}`,
		params,
	);
};

export const deleteConfigurationById = (
	sensorId: string,
	params?: Omit<DeleteConfigurationParams, 'sensorId'>,
) => {
	const uriEncodedSensorId = encodeURIComponent(sensorId);
	return configurations.delete(`/configurations/${uriEncodedSensorId}`, {
		params,
	});
};

export const deleteMultipleConfigurations = ({
	virtualOrPhysical,
	sensorTypes,
	checkOrUncheckedRows,
	headerCheckboxChecked,
	onlyData,
	searchValue,
	dataSourceTypes = [],
}: MultipleDeleteParams) => {
	const params: Record<string, unknown> = {
		onlyData,
	};
	if (headerCheckboxChecked) {
		// delete all, exclude some
		const sensorIdsParam = `*${searchValue}`;
		params.sensorIds = sensorIdsParam;
		const excludedIdsParam = checkOrUncheckedRows
			.map(r => r.sensorId)
			.join(',');
		if (excludedIdsParam) params.excludedIds = excludedIdsParam;

		if (virtualOrPhysical !== 'all')
			params.virtualOrPhysical = virtualOrPhysical;

		const sensorTypesParam = sensorTypes.includes('All')
			? ''
			: sensorTypes.join(',');
		if (sensorTypesParam) params.sensorTypes = sensorTypesParam;

		const dataSourceTypesParam = dataSourceTypes.includes('All')
			? ''
			: dataSourceTypes
					.filter(type =>
						ALLOWED_BULK_DELETE_DATA_SOURCE_TYPES.includes(type),
					)
					.join(',');
		if (dataSourceTypesParam) params.dataSourceTypes = dataSourceTypesParam;
	} else {
		// delete some
		const sensorIdsParam = checkOrUncheckedRows
			.map(r => r.sensorId)
			.join(',');
		params.sensorIds = sensorIdsParam;
	}

	return configurations.delete('/configurations', {
		params,
	});
};
